<template>
    <ModalComponent
        :name="'editar-sancion-' + sancion.id"
        title="Editar sanción"
        v-on:close="() => close()"
        v-if="!loading"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="onSubmit">
            <FormSanciones :sancion="sancion"/>

            <b-button :disabled="loading" type="submit" class="ml-2">Editar</b-button>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormSanciones from './components/FormSanciones';

    export default {
        props: ['base_id', 'sancion'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            async onSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.editarSancion();
                }
            },
            editarSancion() {
                this.loading = true;

                this.sancion.filters = {};
                this.sancion.base_id = this.base_id;
                this.sancion.lista_id = this.lista_id;
                this.sancion.sancion_id = this.sancion.id;

                this.sancion.impuesta = this.sancion.impuesta.id;
                this.sancion.pagar = this.sancion.pagar.id;
                this.sancion.pagado = this.sancion.pagado.id;

                this.$store.dispatch(this.config.getVuexAlias('back.bases.sanciones.editar'), this.sancion).then(() => {
                    this.$toast.success('Sanción editada correctamente');
                    this.$emit('getSanciones');
                }).catch(e => {
                    this.$toast.error(e.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            transformData() {
                const sancionadores = [
                    { id: 0, nombre: 'Federación' },
                    { id: 1, nombre: 'Club' },
                    { id: 2, nombre: 'Cuerpo técnico' }
                ];
                const deudores = [
                    { id: 0, nombre: 'Club' },
                    { id: 1, nombre: 'Deportista' }
                ];
                const pagada = [
                    { id: 1, nombre: 'Pagado' },
                    { id: 0, nombre: 'No pagado' }
                ];

                this.sancion.impuesta = sancionadores.find(item => item.nombre == this.sancion.impuesta) || {};
                this.sancion.pagar = deudores.find(item => item.nombre == this.sancion.pagar) || {};
                this.sancion.pagado = pagada.find(item => item.id == this.sancion.pagado) || {};
            },
            close() {                
                this.$emit('close', 'editar-sancion-' + this.sancion.id);
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        mounted() {
            this.transformData();
        },
        components: {
            ModalComponent, FormSanciones
        }
    }
</script>
